// @flow
import passwordResetEvents from 'app/common/react/components/PasswordReset/utils/passwordResetEvents';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import { track, type TrackingData } from 'app/common/lib/react/analytics';

type Props = {
  usernameOrEmail: ?string,
  logOptions?: TrackingData,
  callBack?: () => void,
  callBackError?: ({
    api_error_code: number,
  }) => void,
  ErrorCallback?: Function,
};

export default ({ usernameOrEmail, logOptions, callBack, ErrorCallback }: Props) => {
  if (logOptions) {
    track(passwordResetEvents.requestEnd, logOptions);
  }

  ResourceFactory.create('UserResetPasswordResource', { username_or_email: usernameOrEmail })
    .callCreate({ showError: false })
    .then(
      (resourceResponse) => {
        if (logOptions) {
          track(passwordResetEvents.request, logOptions);
        }

        if (callBack) {
          callBack();
        }
      },
      (error) => {
        if (ErrorCallback) {
          ErrorCallback(error);
        }
      },
    );
};
